const weightConversion = weight => weight >= 1000 ? `${weight / 1000} т.` : `${weight} кг.`;
export const weightConversionShort = weight => weight >= 1000 ? `${weight / 1000}т` : `${weight}кг`;

export default weightConversion;